import LeadershipInfoInfoModal from './LeadershipInfoInfoModal';
export default LeadershipInfoInfoModal;